import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { replaceAll } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPCuspalPosition ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Cuspal Position');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/cuspalpositionchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

  function handleClickColor(event) {
    if(event.currentTarget.style.backgroundColor==="lightgreen") {
      event.currentTarget.style.backgroundColor="red";
    } else if(event.currentTarget.style.backgroundColor==="red") {
        event.currentTarget.style.backgroundColor="";
    } else {
      event.currentTarget.style.backgroundColor="lightgreen";
    }
  }

  return(
    <>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    {  
      chartData===null||chartData.length===0?(
        <></>
      ):(
      <table class="table  table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
          <caption class="p-0 m-0"><h5 class="p-2 m-0">Cuspal Position</h5></caption>
          <thead>
            <tr class="p-0">
              <th class="p-0 kptable-td">House</th> 
              <th class="p-0 kptable-td">Sign Lord</th> 
              <th class="p-0 kptable-td">Star Lord</th> 
              <th class="p-0 kptable-td">Sub Lord</th> 
              <th class="p-0 kptable-td">Sub Sub Lord</th> 
              <th class="p-0 kptable-td">SSS Lord</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">Sign</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">Planet</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">Star</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-center p-0 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[6].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[9].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[10].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[11].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[12].substring(0,3)}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td d-none d-md-table-cell">{planet[5]}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td d-none d-md-table-cell">{replaceAll(planet[3],",",", ")}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td d-none d-md-table-cell">{planet[7]}</td>
                </tr>
            ))
        }
            </tbody>  
          </table>
      )}
      </>
      );
  }